import React, { useState } from 'react'
import './styles/help.css'
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons"

const Help = () => {
  const [location, setLocation] = useState("login_help")

  const handleSectionChange = (section) => {
    setLocation(section)
  }

  return (
    <>
      <div className='help'>
        <div id="sidebar">
          <div className='logo-section'>
            <img src="https://trainery.one/wp-content/uploads/2023/04/Trainery_One-Logo-white-color-245x48.png" className="logo_image" alt="traineey_logo" />
            <div className="vertical-line"></div>
            <p>Help</p>
          </div>
          <CollapsibleTree SectionChange={handleSectionChange} location={location} />
        </div>
        <div id="main-content">
          {
            location === "location" ?
              <LocationEnableHelp  />

              : location === "login_help" ?
                <LoginHelp />
                : ""
          }
        </div>
      </div>
    </>
  )
}

export default Help


const CollapsibleTree = (props) => {
  const [isOpen, setIsOpen] = useState(1)

  const handleOpenClick = (open) => {
    isOpen === open ? setIsOpen(1) : setIsOpen(open)

  }

  //console.log(props.location, "location")

  return (
    <>
      <div id="sidebar-container">
        <div id="sidebar-content">
          <div id="sidebar-text" onClick={() => { handleOpenClick(0) }}>
            <p>Login an Account</p>
            {
              //console.log(isOpen)
            }
            {isOpen === 1 ? <CaretDownOutlined /> : <CaretUpOutlined />}
          </div>
          {
            isOpen === 1 ? (
              <div id="sidebar-open">
                <ul>
                  <li onClick={() => props.SectionChange("login_help")} style={props.location === "login_help" ? { color: '#f58029' } : {}} >General Help</li>
                  <li onClick={() => props.SectionChange("location")} style={props.location === "location" ? { color: '#f58029' } : {}} >How to enable location</li>
                </ul>
              </div>
            ) : ""
          }

        </div>
      </div>
    </>

  )
}


const ReturnToLogin = () => {
  return (
    <a href="/">
      <button className='go-back-btn'>Go back to Login</button>
    </a>
  )
}

const LoginHelp = () => {
  return (
    <div className="content">
      <div className="heading">
        <h1>General Help</h1>
        <ReturnToLogin/>
      </div>
      <div className="subheading">
        <h2>Logging in using Email ID</h2>
        <div className="explanation-text">
          <p>You can log in normally using your email id, and if your organization has enabled user id login you will need to enter both email and email id</p>
          <div>
          <div className='image'>
            <img src="https://testapps-cdn.trainery.one/help/Login-without-email.png" alt="" style={{objectFit : 'contain'}} />
            
          </div>
          <p>After entering your email and clicking Next, you'll be able to enter your User ID and password</p>
          <div className="image">
            <img src="https://testapps-cdn.trainery.one/help/Enter-User-ID.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <p>You can enter your User ID and password to log into the system, the User ID can be found on your welcome email</p>
          <div className="image">
          <img src="https://testapps-cdn.trainery.one/help/Login-With-All.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <p>You can log in with your credentials and access the application</p>
          </div>
        </div>
      </div>
      <div className="subheading">
        <h2>Logging in using User ID</h2>
        <div className="explanation-text">
          <p>If your organization has enabled User ID login, It is required for you to enter your User ID along with the email id and password, your user ID will be in the activation mail that you recieved when you activated your trainery account</p>
        </div>
      </div>
      <div className="subheading">
        <h2>What is Organization ID</h2>
        <div className="explanation-text">
          <p>An Organization ID is a unique ID given to each organization, when logging in without an email ID, you need to enter your organization's ID to log in</p>
          <div>
          </div>
        </div>
      </div>
      <div className="subheading">
        <h2>90 Day Account deactivation</h2>
        <div className="explanation-text">
          <p>If you have not logged in for more than 90 days, your account gets deactivated for security purposes, in order to access your account again, you will have to change your password using the link in your email</p>
          <div>
            {/* inactive-90-days.png   */}
            <div className="image">
          <img src="https://testapps-cdn.trainery.one/help/inactive-90-days.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          </div>
        </div>
      </div>
      <div className="subheading">
        <h2>How to set a password for the first time</h2>
        <div className="explanation-text">
          <p>When setting your password for the first time you need to make sure that the password meets these criteria</p>
          <ul style={{ padding: '20px' }}>
            <li>At least 8 characters</li>
            <li>Has at least one special character</li>
            <li>has at least one number</li>
            <li>Is not the user's first or last name</li>
            <li>Is not a common password (Eg. Password, Abc@123)</li>
          </ul>
          <p>When clicking on the set password button in your set password mail, you'll be redirected here where you can click 'Click here' to set your password</p>
          <div className='image'>
            <img src="https://testapps-cdn.trainery.one/help/Verified-Set-Password.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <p>After clicking, you'll be sent to this page where you can set your password</p>
          <div className="image">
          <img src="https://testapps-cdn.trainery.one/help/Enter-Password.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <p>Make sure that you enter a strong password which meets these criteria</p>
          <div className="image">
          <img src="https://testapps-cdn.trainery.one/help/Password-criteria.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <p>After setting your password, you'll receive an email with your user id and a link to login to the application, you can now login using that link or by Clicking 'Click here', make sure to save that link for easy access of the application</p>
          <div className="image">
          <img src="https://testapps-cdn.trainery.one/help/Password-Set-Successfully.png" alt="" style={{objectFit : 'contain'}} />
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  )
}

const LocationEnableHelp = () => {
  return (
    <div className="content">
      <div className="heading">
        <h1>How to enable Location?</h1>
        <ReturnToLogin/>
      </div>
      <div className="subheading">
        <h2>Chrome Web Browser</h2>
        <div className="explanation-text">
          <p>To enable location on Chrome you can try reloading the page or you can follow the video below</p>
          <div>
            <video width='900px' height='500px' controls style={{ 'paddingTop': '15px' }}>
              <source src='https://testapps-cdn.trainery.one/help/Chrome.mp4' type='video/mp4' />
            </video>
          </div>
        </div>
      </div>
      <div className="subheading">
        <h2>Firefox Web Browser</h2>
        <div className="explanation-text">
          <p>To enable location on FireFox you can try reloading the page or you can follow the video below</p>
          <div className='video'>
            <video width='900px' height='500px' controls style={{ 'paddingTop': '15px' }}>
              <source src='https://testapps-cdn.trainery.one/help/Firefox.mp4' type='video/mp4' />
            </video>
          </div>
        </div>
      </div>
      <div className="subheading">
        <h2>Brave Web Browser</h2>
        <div className="explanation-text">
          <p>To enable location on Brave you can try reloading the page or you can follow the video below</p>
          <div>
            <video width='900px' height='500px' controls style={{ 'paddingTop': '15px' }}>
              <source src='https://testapps-cdn.trainery.one/help/Brave.mp4' type='video/mp4' />
            </video>
          </div>
        </div>
      </div>
    </div>
  )
}